import { useDispatch } from "react-redux";
import styled from "styled-components";
import { setCompanyAracItem } from "../../features/companyProfile/companyProfileSlice";
import { showModal } from "../../features/modal/modalSlice";

const Container = styled.div`
    width: 100%;
    background-color: ${({theme}) => theme.secondaryBgColor};
    padding: 20px;
    border-radius: 10px;
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    margin-bottom: 20px;

    .content-item{
      display: flex;
      flex-direction: column;
      gap: 5px;
      font-size: var(--font-size-sm);
      color: ${({theme}) => theme.mainTextColor};
      width: calc(33% - 20px);

      .key{
        font-weight: var(--font-weight-lg);
        text-align: center;
      }

      .value{
        font-weight: var(--font-weight-md);
        text-align: center;

      }
    }

    @media (max-width: 600px){

    .content-item{
      width: calc(50% - 20px);

    }
  }


`

const ProfilimAracItemContainerMobile = ({data}) => {

  const dispatch = useDispatch()

  return (
    <Container onClick={() => {dispatch(setCompanyAracItem(data)); dispatch(showModal("companyAracItem"))}}>

      <div className="content-item">
        <div className="key">Plaka</div>
        <div className="value">{data.truckPlateNumber}</div>
      </div>
      <div className="content-item">
        <div className="key">Araç Tipi</div>
        <div className="value">{data.truckType}</div>
      </div>
      <div className="content-item">
        <div className="key">Kasa Tipi</div>
        <div className="value">{data.trailerType}</div>
      </div>
      <div className="content-item">
        <div className="key">Kasko Geçerlilik Tarihi</div>
        <div className="value">{data.kaskoGecerlilikTarihi}</div>
      </div>
      <div className="content-item">
        <div className="key">Muayene Geçerlilik Tarihi</div>
        <div className="value">{data.muayeneGecerlilikTarihi}</div>
      </div>
      <div className="content-item">
        <div className="key">Trafik Sigorta Geçerlilik Tarihi</div>
        <div className="value">{data.trafikSigortasıGecerlilikTarihi}</div>
      </div>
    </Container>
  )
}

export default ProfilimAracItemContainerMobile